import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import styles from './ProductDetails.module.css';
import useProductDetails from '../../hooks/UseProductsDetails';
import { CartContext } from '../contexts/CartContext';

const ProductDetails = () => {
    const { id } = useParams();
    const { product, loading, error } = useProductDetails(id);
    const { addToCart } = useContext(CartContext);

    const [quantity, setQuantity] = useState(1);
    const [isAdded, setIsAdded] = useState(false);
    const [cantAddZero, cantAddZeroToCart] = useState(false);
    const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);

    const handleQuantityChange = (e) => {
        const parsedValue = Math.max(1, parseInt(e.target.value, 10) || 1);
        setQuantity(parsedValue);
    };

    const incrementQuantity = () => setQuantity((prev) => prev + 1);
    const decrementQuantity = () => setQuantity((prev) => Math.max(1, prev - 1));

    const onAddToCart = () => {
        if (!product) return;
        addToCart(product, quantity, null);

        if (quantity > 0) {
            setIsAdded(true);
        } else {
            cantAddZeroToCart(true);
        }

        setTimeout(() => {
            cantAddZeroToCart(false);
            setIsAdded(false);
        }, 1500);
    };

    if (loading) {
        return <h2 className={styles.stateText}>Зареждаме детайлите...</h2>;
    }

    if (error) {
        return <h2 className={styles.stateText}>Възникна грешка: {error}</h2>;
    }

    const productPrice = product?.discount_price ? parseFloat(product.discount_price) : 0;
    const productOldPrice = product?.price ? parseFloat(product.price) : null;
    const priceBGN = productPrice ? (productPrice * 1.9558).toFixed(2) : '0.00';
    const hasDiscount = productOldPrice && productOldPrice > productPrice;
    const discountPercent = hasDiscount
        ? Math.round(((productOldPrice - productPrice) / productOldPrice) * 100)
        : 0;

    return (
        <section id="products" className={styles.page}>
            <div className={styles.container}>
                <div className={styles.galleryCard}>
                    <Swiper
                        spaceBetween={12}
                        slidesPerView={1}
                        navigation
                        loop
                        className={styles.swiperContainer}
                    >
                        {product.images.map((image, index) => (
                            <SwiperSlide key={index} className={styles.swiperSlide}>
                                <img
                                    src={image.image_url}
                                    alt={`${product.productname} - изображение ${index + 1}`}
                                    className={styles.productImage}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                <div className={styles.detailsCard}>
                    <div className={styles.breadcrumbHint}>Колекция Luminis</div>
                    <h1 className={styles.title}>{product.productname}</h1>

                    <div className={styles.priceBlock}>
                        {hasDiscount && (
                            <div className={styles.discountPill}>Спести {discountPercent}%</div>
                        )}
                        {hasDiscount && (
                            <span className={styles.oldPrice}>
                                {productOldPrice?.toFixed(2)} €
                            </span>
                        )}
                        <div className={styles.primaryPriceRow}>
                            <span className={styles.price}>{productPrice.toFixed(2)} €</span>
                            <span className={styles.perUnit}>/ бр.</span>
                        </div>
                        <span className={styles.secondaryPrice}>{priceBGN} лв.</span>
                    </div>

                    <div className={styles.controlsRow}>
                        <div className={styles.quantityStepper}>
                            <button type="button" onClick={decrementQuantity} aria-label="Намали бройката">-</button>
                            <input
                                className={styles.productQuantityInput}
                                type="number"
                                value={quantity}
                                onChange={handleQuantityChange}
                                min="1"
                                inputMode="numeric"
                            />
                            <button type="button" onClick={incrementQuantity} aria-label="Увеличи бройката">+</button>
                        </div>
                        <div className={styles.actionButtons}>
                            <button className={styles.orderButton} onClick={onAddToCart}>
                                Добави в количката
                            </button>
                        </div>
                    </div>

                    <div className={styles.productDescription}>
                        <button onClick={() => setIsDescriptionOpen(!isDescriptionOpen)} className={styles.descriptionToggle}>
                            Описание {isDescriptionOpen ? '−' : '+'}
                        </button>
                        {isDescriptionOpen && (
                            <p className={styles.descriptionText}>
                                {product.description || 'Очаквайте скоро повече информация за продукта.'}
                            </p>
                        )}
                    </div>
                </div>
            </div>

            {isAdded && (
                <div className={styles.modal}>
                    <div className={styles.modalContent}>
                        <p>Успешно добавихте продукта в количката!</p>
                    </div>
                </div>
            )}

            {cantAddZero && (
                <div className={styles.modal}>
                    <div className={styles.modalContent}>
                        <p>Бройката трябва да е поне 1.</p>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ProductDetails;
